var _ellipse, _ellipse2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightCheckboxIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 57,
    viewBox: "0 0 77 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 50.5,
    cy: 30.5,
    rx: 26.5,
    ry: 26.5,
    transform: "rotate(-180 50.5 30.5)",
    fill: "#B4BCC5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.12,
    cx: 21.5,
    cy: 16.5,
    rx: 16.5,
    ry: 16.5,
    transform: "rotate(-180 21.5 16.5)",
    fill: "#B4BCC5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 33.5C47 46.4468 36.5012 57 23.5 57C10.4988 57 0 46.4468 0 33.5C0 20.5532 10.4988 10 23.5 10C36.5012 10 47 20.5532 47 33.5ZM39.2755 28.5498C39.2755 28.0058 39.1123 27.5162 38.7315 27.1354L35.9572 24.3611C35.5764 24.0347 35.0868 23.8171 34.5972 23.8171C34.0532 23.8171 33.5637 24.0347 33.1829 24.3611L20.7257 36.8183L13.8171 29.9097C13.4363 29.5289 12.9468 29.3113 12.4028 29.3113C11.9132 29.3113 11.4236 29.5289 11.0428 29.9097L8.26852 32.684C7.88773 33.0648 7.72454 33.5544 7.72454 34.0984C7.72454 34.588 7.88773 35.0775 8.26852 35.4583L19.3657 46.5556C19.6921 46.8819 20.2361 47.0995 20.7257 47.0995C21.2153 47.0995 21.7593 46.8819 22.14 46.5556L38.7315 29.9097C39.1123 29.5289 39.2755 29.0394 39.2755 28.5498Z",
    fill: "#888F99"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightCheckboxIcon);
export default __webpack_public_path__ + "static/media/light_checkbox_icon.648cfb08f8391f2d6f77ee57a060d126.svg";
export { ForwardRef as ReactComponent };